import { render, staticRenderFns } from "./IconAI.vue?vue&type=template&id=55948a88"
import script from "./IconAI.vue?vue&type=script&lang=js"
export * from "./IconAI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports